exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".addressPage .mobileNumber{margin-top:20px}.addressPage button{margin:25px 0 50px}", "", {"version":3,"sources":["/home/bamboo/applications/bamboo-home/xml-data/build-dir/AAI-SCFR-JOB1/src/page-components/src/page-components/AddressPage.scss"],"names":[],"mappings":"AAAA,2BAGI,eAAgB,CAHpB,oBAOI,kBAAmB,CACpB","file":"AddressPage.scss","sourcesContent":[".addressPage {\n\n  .mobileNumber {\n    margin-top: 20px;\n  }\n\n  button {\n    margin: 25px 0 50px;\n  }\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/sass-loader/lib/loader.js?sourceMap!./src/page-components/AddressPage.scss
// module id = 1296
// module chunks = 0